module.exports = __webpack_public_path__ + "static/media/hollow-cut-facebook.a0231198.svg";